import type { ReactNode } from 'react';
import { ProcessStepsInfographic, type ProcessStepItem } from '@/components/ProcessStepsInfographic';
import { useI18n, type MessageKey } from '@/features/i18n/I18nProvider';

const stepDefs: { n: string; titleKey: MessageKey; textKey: MessageKey; icon: ReactNode }[] = [
  {
    n: '01',
    titleKey: 'home.step1.title',
    textKey: 'home.step1.text',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z" />
      </svg>
    ),
  },
  {
    n: '02',
    titleKey: 'home.step2.title',
    textKey: 'home.step2.text',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <path d="M9 12h6M9 16h4" />
      </svg>
    ),
  },
  {
    n: '03',
    titleKey: 'home.step3.title',
    textKey: 'home.step3.text',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
      </svg>
    ),
  },
  {
    n: '04',
    titleKey: 'home.step4.title',
    textKey: 'home.step4.text',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>
    ),
  },
  {
    n: '05',
    titleKey: 'home.step5.title',
    textKey: 'home.step5.text',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M3 3v18h18" />
        <path d="M7 14l4-4 4 4 5-6" />
      </svg>
    ),
  },
];

type Props = {
  surface?: 'default' | 'none';
};

export function MarketingParcoursSteps({ surface = 'default' }: Props) {
  const { t } = useI18n();

  const steps: ProcessStepItem[] = stepDefs.map((s) => ({
    num: s.n,
    title: t(s.titleKey),
    description: t(s.textKey),
    icon: s.icon,
  }));

  return (
    <ProcessStepsInfographic
      steps={steps}
      columns={5}
      ariaLabel={t('home.parcours.eyebrow')}
      surface={surface}
    />
  );
}
